<section class="relative flex flex-col items-center overflow-hidden py-24">
  <div
    class="absolute inset-0 grid grid-cols-3 gap-8 opacity-20 md:grid-cols-4 lg:grid-cols-5"
  >
    @for (integration of visibleIntegrations; track integration.src) {
      <div class="flex items-center justify-center">
        @defer {
          <img
            [alt]="integration.alt"
            [src]="integration.src"
            class="h-16 w-16 object-contain grayscale"
          />
        } @placeholder {
          <div class="h-16 w-16 animate-pulse bg-gray-200"></div>
        }
      </div>
    }
  </div>

  <div class="relative z-10 flex flex-col items-center gap-4 text-center">
    <h2 class="text-3xl font-bold md:text-4xl">Seamless Integrations</h2>
    <p class="text-balance text-xl">
      Easily connect with your favorite tools and services.
    </p>
  </div>
</section>
